import React, { useContext, useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
import { makeClient } from "@therms/downloads-api";
//#region src/contexts/DownloadsApiServiceContext.tsx
/**
* Use this context to wrap an entire web-app so
*/
var DownloadsApiServiceContext = React.createContext({});
var DownloadsApiServiceContextProvider = ({ children, clientConfig }) => {
	const [authToken, setAuthToken] = useState("");
	const [regionIds, setRegionIds] = useState([]);
	const client = useMemo(() => {
		return makeClient({
			...clientConfig,
			headers: {
				authToken,
				regionIds
			}
		});
	}, [
		authToken,
		clientConfig,
		regionIds
	]);
	return /* @__PURE__ */ jsx(DownloadsApiServiceContext.Provider, {
		value: {
			client,
			setAuthToken,
			setRegionIds
		},
		children
	});
};
var useDownloadsApiServiceContext = (opts = { ctxRequired: true }) => {
	const ctx = useContext(DownloadsApiServiceContext);
	if (opts.ctxRequired && !ctx) throw new Error("context is required for useDownloadsApiServiceContext()");
	return ctx;
};
//#endregion
export { DownloadsApiServiceContext, DownloadsApiServiceContextProvider, useDownloadsApiServiceContext };

//# sourceMappingURL=DownloadsApiServiceContext.js.map